export default __webpack_public_path__ + "static/media/photo-robin.e6373fcd.jpeg";